import {COMPONENT_STATES, FETCHING_STATES} from "../../core/consts";
import {BaseState} from "../models/base-state";
import {computed, makeObservable, observable} from "mobx";
import {BaseTerms} from "../models/base-terms";

export class BaseMobxState extends BaseState {
  @observable fetchingState: FETCHING_STATES;
  @observable componentState: COMPONENT_STATES;
  @observable error: Error;
  @observable terms: BaseTerms = {};

  static injectables = [];

  constructor() {
    super();

    this.fetchingState = FETCHING_STATES.idle;
    this.componentState = COMPONENT_STATES.notReady;

    makeObservable(this);
  }

  @computed get isPopulated(): Boolean {
    return true;
  }

  @computed get hasError(): Boolean {
    return !!this.error;
  }

  onUnload() {

  }
}
